import './nav.scss';
import Sloth from '../Sloth';
import $ from 'jquery';

@Sloth.component({
    defaultOptions : {
        phoneicon : '.Nav-icon' // 手机端点击出菜单的按钮
    }
})

export default class Nav {
    onInit() {
        const obj = this.dom;
        const options = this.options;
        const phoneicon = $(options.phoneicon);
        const nav = obj;
        const eventName = Modernizr.touch ? 'touchstart' : 'click';

        phoneicon.on(eventName, () => {
            const offsetTop = phoneicon.offset().top;
            const offsetHeight = phoneicon.innerHeight();
            nav.css('top', offsetTop + offsetHeight);

            if (nav.is(':visible')) {
                nav.removeAttr('style');
            } else {
                nav.show();
            }
        });

        $(document).on(eventName, (evt) => {
            if (!phoneicon.is(':visible') || !$(obj).is(':visible')) {
                return;
            }
            if ($(evt.target).closest(obj).length === 0 && !$(evt.target).is(phoneicon)) {
                $(obj).removeAttr('style');
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./components/Nav/nav.js
 **/